import Input from '@material-ui/core/Input';

import SearchIcon from './icons/SearchIcon';

const styles = () => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },

  fullWidth: {
    width: '100%',
  },

  searchIcon: {
    flexShrink: 0,
    marginLeft: 10,
  },
});

class SearchTextField extends React.Component {
  render() {
    const { className, classes, onSearch, fullWidth, ...props } = this.props;
    return (
      <div
        className={classnames(className, classes.root, {
          [classes.fullWidth]: fullWidth,
        })}>
        <Input
          {...props}
          fullWidth
          onChange={onSearch}
          startAdornment={<SearchIcon className={classes.searchIcon} />}
          inputProps={{ className: classes.input }}
        />
      </div>
    );
  }
}

SearchTextField.defaultProps = {
  key: 'search-input',
};

export default withStyles(styles)(SearchTextField);
